/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RelatedPartiesCountsViewModel } from './RelatedPartiesCountsViewModel';
import {
    RelatedPartiesCountsViewModelFromJSON,
    RelatedPartiesCountsViewModelFromJSONTyped,
    RelatedPartiesCountsViewModelToJSON,
} from './RelatedPartiesCountsViewModel';
import type { SimplifiedLookupResponseViewModel } from './SimplifiedLookupResponseViewModel';
import {
    SimplifiedLookupResponseViewModelFromJSON,
    SimplifiedLookupResponseViewModelFromJSONTyped,
    SimplifiedLookupResponseViewModelToJSON,
} from './SimplifiedLookupResponseViewModel';
import type { ThirdPartiesSectionViewModel } from './ThirdPartiesSectionViewModel';
import {
    ThirdPartiesSectionViewModelFromJSON,
    ThirdPartiesSectionViewModelFromJSONTyped,
    ThirdPartiesSectionViewModelToJSON,
} from './ThirdPartiesSectionViewModel';
import type { ThirdPartySingleSection } from './ThirdPartySingleSection';
import {
    ThirdPartySingleSectionFromJSON,
    ThirdPartySingleSectionFromJSONTyped,
    ThirdPartySingleSectionToJSON,
} from './ThirdPartySingleSection';

/**
 * 
 * @export
 * @interface ThirdPartiesViewModel
 */
export interface ThirdPartiesViewModel {
    /**
     * 
     * @type {string}
     * @memberof ThirdPartiesViewModel
     */
    clientNameWording: string;
    /**
     * 
     * @type {ThirdPartySingleSection}
     * @memberof ThirdPartiesViewModel
     */
    actingOnBehalfOf?: ThirdPartySingleSection;
    /**
     * 
     * @type {ThirdPartiesSectionViewModel}
     * @memberof ThirdPartiesViewModel
     */
    financialContributors?: ThirdPartiesSectionViewModel;
    /**
     * 
     * @type {ThirdPartiesSectionViewModel}
     * @memberof ThirdPartiesViewModel
     */
    beneficiaries?: ThirdPartiesSectionViewModel;
    /**
     * 
     * @type {ThirdPartiesSectionViewModel}
     * @memberof ThirdPartiesViewModel
     */
    alternativeBeneficiaries?: ThirdPartiesSectionViewModel;
    /**
     * 
     * @type {ThirdPartiesSectionViewModel}
     * @memberof ThirdPartiesViewModel
     */
    nominees?: ThirdPartiesSectionViewModel;
    /**
     * 
     * @type {ThirdPartySingleSection}
     * @memberof ThirdPartiesViewModel
     */
    nomineesForOwnership?: ThirdPartySingleSection;
    /**
     * 
     * @type {ThirdPartiesSectionViewModel}
     * @memberof ThirdPartiesViewModel
     */
    lifeInsured?: ThirdPartiesSectionViewModel;
    /**
     * 
     * @type {Array<RelatedPartiesCountsViewModel>}
     * @memberof ThirdPartiesViewModel
     */
    relatedPartiesCounts?: Array<RelatedPartiesCountsViewModel>;
    /**
     * 
     * @type {ThirdPartiesSectionViewModel}
     * @memberof ThirdPartiesViewModel
     */
    payees?: ThirdPartiesSectionViewModel;
    /**
     * 
     * @type {string}
     * @memberof ThirdPartiesViewModel
     */
    frontEndTotalRelatedPartiesError?: string;
    /**
     * 
     * @type {Array<SimplifiedLookupResponseViewModel>}
     * @memberof ThirdPartiesViewModel
     */
    filteredRelations?: Array<SimplifiedLookupResponseViewModel>;
    /**
     * 
     * @type {boolean}
     * @memberof ThirdPartiesViewModel
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the ThirdPartiesViewModel interface.
 */
export function instanceOfThirdPartiesViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientNameWording" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function ThirdPartiesViewModelFromJSON(json: any): ThirdPartiesViewModel {
    return ThirdPartiesViewModelFromJSONTyped(json, false);
}

export function ThirdPartiesViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThirdPartiesViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientNameWording': json['ClientNameWording'],
        'actingOnBehalfOf': !exists(json, 'ActingOnBehalfOf') ? undefined : ThirdPartySingleSectionFromJSON(json['ActingOnBehalfOf']),
        'financialContributors': !exists(json, 'FinancialContributors') ? undefined : ThirdPartiesSectionViewModelFromJSON(json['FinancialContributors']),
        'beneficiaries': !exists(json, 'Beneficiaries') ? undefined : ThirdPartiesSectionViewModelFromJSON(json['Beneficiaries']),
        'alternativeBeneficiaries': !exists(json, 'AlternativeBeneficiaries') ? undefined : ThirdPartiesSectionViewModelFromJSON(json['AlternativeBeneficiaries']),
        'nominees': !exists(json, 'Nominees') ? undefined : ThirdPartiesSectionViewModelFromJSON(json['Nominees']),
        'nomineesForOwnership': !exists(json, 'NomineesForOwnership') ? undefined : ThirdPartySingleSectionFromJSON(json['NomineesForOwnership']),
        'lifeInsured': !exists(json, 'LifeInsured') ? undefined : ThirdPartiesSectionViewModelFromJSON(json['LifeInsured']),
        'relatedPartiesCounts': !exists(json, 'RelatedPartiesCounts') ? undefined : ((json['RelatedPartiesCounts'] as Array<any>).map(RelatedPartiesCountsViewModelFromJSON)),
        'payees': !exists(json, 'Payees') ? undefined : ThirdPartiesSectionViewModelFromJSON(json['Payees']),
        'frontEndTotalRelatedPartiesError': !exists(json, 'FrontEndTotalRelatedPartiesError') ? undefined : json['FrontEndTotalRelatedPartiesError'],
        'filteredRelations': !exists(json, 'FilteredRelations') ? undefined : ((json['FilteredRelations'] as Array<any>).map(SimplifiedLookupResponseViewModelFromJSON)),
        'isComplete': json['IsComplete'],
    };
}

export function ThirdPartiesViewModelToJSON(value?: ThirdPartiesViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ClientNameWording': value.clientNameWording,
        'ActingOnBehalfOf': ThirdPartySingleSectionToJSON(value.actingOnBehalfOf),
        'FinancialContributors': ThirdPartiesSectionViewModelToJSON(value.financialContributors),
        'Beneficiaries': ThirdPartiesSectionViewModelToJSON(value.beneficiaries),
        'AlternativeBeneficiaries': ThirdPartiesSectionViewModelToJSON(value.alternativeBeneficiaries),
        'Nominees': ThirdPartiesSectionViewModelToJSON(value.nominees),
        'NomineesForOwnership': ThirdPartySingleSectionToJSON(value.nomineesForOwnership),
        'LifeInsured': ThirdPartiesSectionViewModelToJSON(value.lifeInsured),
        'RelatedPartiesCounts': value.relatedPartiesCounts === undefined ? undefined : ((value.relatedPartiesCounts as Array<any>).map(RelatedPartiesCountsViewModelToJSON)),
        'Payees': ThirdPartiesSectionViewModelToJSON(value.payees),
        'FrontEndTotalRelatedPartiesError': value.frontEndTotalRelatedPartiesError,
        'FilteredRelations': value.filteredRelations === undefined ? undefined : ((value.filteredRelations as Array<any>).map(SimplifiedLookupResponseViewModelToJSON)),
        'IsComplete': value.isComplete,
    };
}

